import './styles/Status.css';
import { useSupportStatusQuery } from 'pages/Support/Status/useSupportStatusQuery';

import { type FC, memo } from 'react';
import { Link } from 'react-router-dom';

const getDotColorClassName = (number: number | null): string => {
  if (number === null) {
    return 'bg-gray';
  }
  if (number <= 60) {
    return 'bg-green';
  }
  if (number <= 80) {
    return 'bg-yellow';
  }
  return 'bg-red';
};

const StatusRow: FC<{
  label: string;
  dotColorClassName: string;
  text: string | null;
}> = (props) => (
  <tr>
    <td className='status-menu__cell'>
      <span
        className={`status-menu__color align-middle ${props.dotColorClassName}`}
      />
    </td>
    <td className='status-menu__cell'>{props.label}</td>
    <td className='status-menu__cell text-right min-w-8 py-1px px-0.5'>
      {props.text}
    </td>
  </tr>
);

const LoadRow: FC<{
  load: number | null;
  perCorePercent: number | null;
}> = (props) => (
  <StatusRow
    label='Load'
    dotColorClassName={getDotColorClassName(
      props.perCorePercent === null ? null : Math.round(props.perCorePercent),
    )}
    text={props.load?.toFixed(2) ?? null}
  />
);

const PercentRow: FC<{ label: string; percent: number | null }> = (props) => {
  const percent = props.percent === null ? null : Math.round(props.percent);
  return (
    <StatusRow
      label={props.label}
      dotColorClassName={getDotColorClassName(percent)}
      text={percent !== null ? `${percent} %` : null}
    />
  );
};

export const HeaderSystemStatus = memo(() => {
  const statusQuery = useSupportStatusQuery();
  return (
    <Link to='/support/status' className='status-menu-link'>
      <table className='mx-0.5'>
        <tbody>
          <LoadRow
            load={statusQuery.data?.parsed.cpu.load1m ?? null}
            perCorePercent={
              statusQuery.data?.parsed.cpu.load1mPerCorePercent ?? null
            }
          />
          <PercentRow
            label='RAM'
            percent={statusQuery.data?.parsed.memory.usedPercent || null}
          />
          <PercentRow
            label='HDD'
            percent={statusQuery.data ? statusQuery.data.disk.usedPct : null}
          />
        </tbody>
      </table>
    </Link>
  );
});
